import { apiGet } from '../../api'

export const get_groups = () => {
  return apiGet({
    endpoint: `groups/get_groups`
  })
}
